/// <amd-module name="SearchUI/Components/SearchPickList/ExpandableSearchPickListMenu" />

import * as React from "react";
import * as ReactDOM from "react-dom";
import { ISearchPickListMenuProps } from "SearchUI/Components/SearchPickList/SearchPickList.Props";
import { SearchPickListMenu } from "SearchUI/Components/SearchPickList/SearchPickListMenu";

export interface IExpandableSearchPickListMenuState {
    width: number;

    height: number;

    lastMouseX: number;

    lastMouseY: number;

    resizing: boolean;
}

export class ExpandableSearchPickListMenu extends React.Component<ISearchPickListMenuProps, IExpandableSearchPickListMenuState> {
    constructor(props: ISearchPickListMenuProps) {
        super(props);
        this.state = {} as IExpandableSearchPickListMenuState;
    }

    public render(): JSX.Element {
        const { width, height } = this.state,
            { menuMaxWidth } = this.props;

        return <SearchPickListMenu {...this.props}
            width={width}
            height={height}
            onResizing={this._onResizing}
            isExpandable={true}
            menuMaxWidth={menuMaxWidth} />;
    }

    private _onResizing = (width: number, height: number, evt: React.MouseEvent<HTMLElement>): void => {
        const { ownerDocument } = ReactDOM.findDOMNode(this);

        evt.preventDefault();
        evt.stopPropagation();

        ownerDocument.addEventListener('mousemove', this._onMouseMove);
        ownerDocument.addEventListener('mouseup', this._onMouseUp);

        this.setState({
            width: width,
            height: height,
            lastMouseX: evt.clientX,
            lastMouseY: evt.clientY,
            resizing: true
        });
    }

    /**
     * Updates Width and height of the container as the mouse moves, while resizing the container
     * @param evt
     */
    private _onMouseMove = (evt: MouseEvent): void => {
        if (this.state.resizing) {
            const { width, height, lastMouseX, lastMouseY } = this.state,
                { clientX, clientY } = evt;
            let finalWidth = (width + clientX - lastMouseX),
                finalHeight = (height + clientY - lastMouseY);

            this.setState({
                width: finalWidth,
                height: finalHeight,
                lastMouseX: clientX,
                lastMouseY: clientY
            });
        }
    }

    /**
     * Remove resize mouse event listeners on mouse up
     * @param evt
     */
    private _onMouseUp = (evt: MouseEvent): void => {
        const { ownerDocument } = ReactDOM.findDOMNode(this);
        ownerDocument.removeEventListener('mousemove', this._onMouseMove);
        ownerDocument.removeEventListener('mouseup', this._onMouseUp);
        this.setState({ resizing: false });
    }
}